import { render } from "./AnagraficaClienti.vue?vue&type=template&id=1044167a"
import script from "./AnagraficaClienti.vue?vue&type=script&lang=js"
export * from "./AnagraficaClienti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__